import React, { useMemo, useState } from "react";
import NoBrandImage from "../NoBrandImage";
import IconButton from "../IconButton";
import { EditPencilIcon } from "../EditPencilIcon";

interface BrandDisplayCardProps {
    brand: any;
    onEdit?: (brand: any) => void;
    currentUser?: any;
}

const BrandDisplayCard = ({ brand, onEdit, currentUser }: BrandDisplayCardProps) => {
    const [imgError, setImgError] = useState(false);

    const imageUrl = useMemo(() => {
        const candidate = brand?.mediaPreviewUrl || brand?.mediaUrl || brand?.brandLogoUrl || '';
        return String(candidate || '').trim();
    }, [brand]);

    const hasImage = Boolean(imageUrl) && !imgError;

    if (!brand) return null;

    return (
        <div className="card live-preview-shell brand-display-card" data-testid={`brand-card-${brand.id}`}>
            <div className="live-preview-media" data-testid={`brand-card-logo-${brand.id}`} aria-label="Brand logo preview">
                <div className={`live-preview-media-hero${hasImage ? ' live-preview-media-hero--filled' : ' live-preview-media-hero--empty'}`}>
                    {hasImage ? (
                        <img
                            data-testid={`brand-card-logo-image-${brand.id}`}
                            src={imageUrl}
                            alt={String(brand?.name || 'Brand logo')}
                            onError={() => setImgError(true)}
                        />
                    ) : (
                        <div className="live-preview-media-empty" data-testid={`brand-card-logo-empty-${brand.id}`} aria-label="No brand logo">
                            <NoBrandImage />
                        </div>
                    )}
                </div>
            </div>

            <div className="live-preview-card-top">
                <div className="live-preview-name-row">
                    <div className="live-preview-name" data-testid={`brand-card-name-${brand.id}`}>{brand.name}</div>
                </div>
            </div>

            {onEdit && (
                <div className="live-preview-actions">
                    {(currentUser?.roleActions?.indexOf('WriteBrands') >= 0 ||
                      currentUser?.roleActions?.indexOf('AdminBrands') >= 0) && <IconButton
                        title="Edit"
                        ariaLabel={`Edit ${brand.name || 'brand'}`}
                        onClick={() => onEdit(brand)}
                        testId={`brand-edit-${brand.id}`}
                    >
                        <EditPencilIcon />
                    </IconButton>}
                </div>
            )}
        </div>
    );
};

export default BrandDisplayCard;
